import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isSaving: false,
  content: null,
  error: null,
};

const healthInsuranceSlice = createSlice({
  name: "healthInsurance",
  initialState,
  reducers: {
    // GET CONTENT
    getHealthInsuranceContentRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getHealthInsuranceContentSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        content: action.payload,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getHealthInsuranceContentFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // UPDATE CONTENT
    updateHealthInsuranceRequest: {
      reducer: (state) => ({
        ...state,
        isSaving: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateHealthInsuranceSuccess: {
      reducer: (state, action) => ({
        ...state,
        isSaving: false,
        content: action.payload,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateHealthInsuranceFailure: {
      reducer: (state, action) => ({
        ...state,
        isSaving: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // CLEAR ERROR
    clearHealthInsuranceError: (state) => ({
      ...state,
      error: null,
    }),
  },
});

export const {
  getHealthInsuranceContentRequest,
  getHealthInsuranceContentSuccess,
  getHealthInsuranceContentFailure,
  updateHealthInsuranceRequest,
  updateHealthInsuranceSuccess,
  updateHealthInsuranceFailure,
  clearHealthInsuranceError,
} = healthInsuranceSlice.actions;

export default healthInsuranceSlice.reducer;
